/**
 * Created by dv on 7/12/2017.
 */
import {
  EditZmCollectionAssetsMessage,
  EditZmCollectionAssetsQuery,
} from "../../../autogenerated/ZoomBridge";

/**
 * Add assets to a existing collection
 */
export default class AddZmCollectionAssets {
  /**
   *
   * @param {number} collectionId CollectionId to which the assets need to be added.
   * @param {Array.<FuidRrnInfo>} fuidRrnList. List of fuid and rrn for assets to be added
   * @param {ImportQueryResponse} For imported files
   */
  constructor(collectionId, fuidRrnList, importQueryResponse) {
    this.collectionId = collectionId;
    this.fuidRrnList = fuidRrnList;
    this.importQueryResponse = importQueryResponse;
  }

  /**
   * Returns a {Promise} Instance with onSuccess and OnFailure method.
   * onSuccess method takes resp{SimpleResponse} type.
   * @return {Promise}
   * @public
   */
  run() {
    const query = new EditZmCollectionAssetsQuery();
    const msg = new EditZmCollectionAssetsMessage();
    msg.setCollectionId(this.collectionId);
    msg.setFuidRrnList(this.fuidRrnList);
    msg.setImportQueryResponse(this.importQueryResponse);
    query.message = msg;
    return query.run();

  }
}
